import UI from './UI'
import { cleanStoreAction, fetchCourseAction, fetchCurrentCourseReviewAction } from 'pages/Course/store'
import { connect } from 'react-redux'
import { clearQuizAction, fetchQuizContentAction, getQuizHistoryAction } from './Quizz/store'

const mapStateToProps = ({ course, identity, quiz }) => ({
  IsAccessible: course?.Course?.IsAccessible,
  IsVisible: course?.Course?.IsVisible,
  loading: course.gettingCoursesInfos,
  selectedCourse: course?.Course,
  IsFree: course?.Course?.IsFree,
  isConnected: identity.isConnected,
  reviewStart: course.createReview.isStarting,
  courseId: course?.Course?.Id,
  isQuizOpen: quiz?.isQuizOpen
})

const mapDispatchToProps = (dispatch) => ({
  fetchCourse: (slug, videoSlug) => dispatch(fetchCourseAction(slug, videoSlug)),
  cleanStore: _ => dispatch(cleanStoreAction()),
  clearQuizAction: _ => dispatch(clearQuizAction()),
  fetchCurrentCourseReviewAction: (slug) => dispatch(fetchCurrentCourseReviewAction(slug)),
  fetchQuizContentAction: (slug) => dispatch(fetchQuizContentAction(slug)),
  getQuizHistoryAction: (courseId) => dispatch(getQuizHistoryAction(courseId))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
